import React from 'react';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import { Spacer } from '../spacer/spacer';
import styles from './in-page-loader.module.scss';

export const InPageLoader: React.FC = () => {
  return (
    <div className={styles.root}>
      <Spacer size="06" />
      <LoadingSpinner size="big" variant="rectangle" />
      <Spacer size="06" />
    </div>
  );
};
